import Svg, { Path } from "react-native-svg"
import { useTheme } from "styled-rn"

import { IconProps } from "./SvgIcons"

export const BookIcon = (props: IconProps) => {
  const theme = useTheme()

  return (
    <Svg width={props.width} viewBox="0 0 19 21">
      <Path
        d="M17.3 5.25v11.375H12.98c-.936 0-1.844.32-2.593.89V17.5c0-1.444 1.167-2.625 2.593-2.625h1.728c.23 0 .447-.088.605-.262.159-.175.26-.38.26-.613V5.25H17.3ZM6.064 16.625H1.743V5.25h4.321c1.426 0 2.593 1.181 2.593 2.625v9.64a4.296 4.296 0 0 0-2.593-.89Zm4.322-12.25c0-1.444 1.167-2.625 2.593-2.625h.864v11.375h-.864c-.936 0-1.844.32-2.593.904V4.375Zm2.11-4.113c-1.152 0-1.764.205-2.586 1.021a4.424 4.424 0 0 0-1.267 3.092v.03A4.31 4.31 0 0 0 6.05 3.5H.864A.872.872 0 0 0 0 4.375V17.5c0 .233.086.452.26.612.172.16.374.263.604.263H6.05a2.58 2.58 0 0 1 2.492 1.969c.1.379.447.656.836.656h.244a.88.88 0 0 0 .836-.656c.288-1.152 1.325-1.97 2.492-1.97h5.186c.23 0 .446-.087.605-.262.158-.16.259-.379.259-.612V4.375a.82.82 0 0 0-.26-.612.858.858 0 0 0-.604-.263h-2.593V.875c0-.233-2.477-.547-2.752-.613h-.294Z"
        fill={theme[props.fill]}
      />
    </Svg>
  )
}
